import { useCallback } from 'react';

import { Box } from '@cast/design-system';
import {
  buildInventoryWorkloadViewPath,
  WORKLOAD_CATEGORIES,
  WORKLOAD_VIEWS,
} from '@cast/features-cluster-inventory-workloads';
import { clusterDashboardChartZoomProps } from '@cast/features-cluster-shared';
import {
  OomKillsScatterChart,
  type OomKillBucketQueryRange,
  type OomKillWorkloadHrefArgs,
  type OOMKillChartItem,
} from '@cast/split-me/features/cluster/dashboard/WorkloadEventMetricsSection';

type OomKillsChartProps = {
  data: OOMKillChartItem[];
  timeZone: string;
  rangeSelection: OomKillBucketQueryRange;
  isLoading?: boolean;
  hasNoData?: boolean;
  testId?: string;
};

export const OomKillsChart = ({
  data,
  timeZone,
  rangeSelection,
  isLoading,
  hasNoData,
  testId = 'oom-kills-chart',
}: OomKillsChartProps) => {
  const getWorkloadHref = useCallback(
    ({ clusterId, workloadId }: OomKillWorkloadHrefArgs) =>
      buildInventoryWorkloadViewPath({
        clusterId,
        workloadId,
        view: WORKLOAD_VIEWS.DASHBOARD,
        category: WORKLOAD_CATEGORIES.AUTOSCALING,
      }),
    []
  );

  return (
    <Box height={315} width="100%">
      <OomKillsScatterChart
        data={data}
        timeZone={timeZone}
        isLoading={isLoading}
        hasNoData={hasNoData}
        testId={testId}
        rangeSelection={rangeSelection}
        getWorkloadHref={getWorkloadHref}
        zoomProps={clusterDashboardChartZoomProps}
        chartActionsSx={{ top: 0, right: 0 }}
        sx={{ height: '100%' }}
      />
    </Box>
  );
};
